<template>
  <b-modal id="project-privacy-modal" size="lg" ref="projectPrivacyModal" no-close-on-backdrop body-class="p-0"
    centered>
    <template slot="modal-header" class="mx-auto">
      <div>
        <h4 class="">Project Privacy</h4>
        <p class="mb-0">
          Who can access your project data?
        </p>
      </div>

    </template>
    <template slot="default">
      <b-form-group class="p-4" stacked v-slot="{ ariaDescribedby }">
        <b-form-radio v-model="privacy" :aria-describedby="ariaDescribedby" name="privacy-radios" :value="false"
          size="lg">
          <b-img class='mr-2' src="/assets/images/public.png" width="50px" height="50px" alt="public"
            title="Everyone, including non-members, can see project information: including forum and resources. Any data accessible to project members, will be accessible to the public. Specific data can be made private via other settings."></b-img><span
            class="h3">Public</span>
          <b-form-group label-cols="12" label-size="md" label="">
            <span>
              Everyone, including non-members, can see project information: including forum and resources.
              Any data accessible to project members, will be accessible to the public.
              Specific data can be made private via other settings.</span>
          </b-form-group>
        </b-form-radio>
        <br>
        <b-form-radio v-model="privacy" :aria-describedby="ariaDescribedby" name="privacy-radios" :value="true"
          size="lg">
          <b-img class='mr-2' src="/assets/images/private.png" width="50px" height="50px" alt="private"
            title="Only members can see project forum and resources. No data will be accessible to the public."></b-img><span
            class="h3">Private (Members Only)</span>
          <b-form-group label-cols="12" label-size="md" label="" label-for="input-sm">
            <span>
              Only members can see project forum and resources.
              No data will be accessible to the public.
              Tip: As a project manager, you have the option to make datasheets and/or questions private.
            </span>
          </b-form-group>
        </b-form-radio>
      </b-form-group>
    </template>
    <template #modal-footer>
      <span class="mr-5">Save the Project to apply this change</span>
      <b-button size="md" variant="primary" @click="onClose()">
        Done
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  props: {
    privacyValue: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      // default privacy value is public
      privacy: false,
    }
  },
  mounted() {
  },
  created() {
    console.log('privacy prop', this.privacyValue, JSON.stringify(this.privacy))
    this.privacy = this.privacyValue
    console.log('privacy prop', this.privacyValue, JSON.stringify(this.privacy))
  },
  watch: {
    privacyValue(newVal, oldVal) {
      if (newVal) {
        this.privacy = newVal
      }
    }
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    ...mapActions({}),

    onClose() {
      // emit data value to parent component
      this.$emit('privacyChange', this.privacy);
      // close modal
      this.$refs.projectPrivacyModal.hide()
    }
  },
}

</script>

<style scoped lang="scss"></style>
